export const THEME_BUILDER_API_URL = 'https://wpp-app-theme-builder-api-tccc-dev-stage.playground-stage.coke.com' || 'http://localhost:8080'
